<template>
    <div>
        <div class="current_time">{{ currentTime }}</div>
        <el-card>
            <p class="title_p">基本信息</p>
            <ul class="dis_flex">
                <li v-for="(item,index) in BmsList" :key="index">
                    <p>{{ item.tag || 0 }}</p>
                    <p class="schedule">
                        <span :style="{width: (item.soc || 0) + '%'}"></span>
                    </p>
                    <p>SOC: {{ (item.soc || 0) + '%' }}</p>
                </li>
            </ul>
        </el-card>
        <el-card>
            <p class="title_p">温压信息</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div"  v-for="(item,index) in BmsList" :key="index">
                    <el-form-item label="电压：" label-width="120px">{{ item.voltage || 0 }} V</el-form-item>
                    <el-form-item label="电流：" label-width="120px">{{ item.current || 0 }} A</el-form-item>
                    <el-form-item label="功率：" label-width="120px">{{ item.power || 0 }} KW</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">电压</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" v-for="(item,index) in BmsList" :key="index">
                    <el-form-item label="簇压差：" label-width="120px">{{ item.voltageDifference || 0 }} mv</el-form-item>
                    <el-form-item label="簇温差：" label-width="120px">{{ item.tempDifference || 0 }} °c</el-form-item>
                    <el-form-item label="最高：" label-width="120px">{{ item.maxSingleVoltage || 0 }} mv</el-form-item>
                    <el-form-item label="箱号/内序号：" label-width="120px">{{ item.maxSingleVoltageCabinetNo || 0 }} / {{ item.maxSingleVoltageCabinetSeq || 0 }}</el-form-item>
                    <el-form-item label="最低：" label-width="120px">{{ item.minSingleVoltage || 0 }} mv</el-form-item>
                    <el-form-item label="箱号/内序号：" label-width="120px">{{ item.minSingleVoltageCabinetNo || 0 }} / {{ item.minSingleVoltageCabinetSeq || 0 }}</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">温度</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" v-for="(item,index) in BmsList" :key="index">
                    <el-form-item label="最高：" label-width="120px">{{ item.maxTemp || 0 }} °c</el-form-item>
                    <el-form-item label="箱号/内序号：" label-width="120px">{{ item.maxTempCabinetNo || 0 }} / {{ item.maxTempCabinetSeq || 0 }}</el-form-item>
                    <el-form-item label="最低：" label-width="120px">{{ item.minTemp || 0 }} °c</el-form-item>
                    <el-form-item label="箱号/内序号：" label-width="120px">{{ item.minTempCabinetNo || 0 }} / {{ item.minTempCabinetSeq || 0 }}</el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>
<script>

import { AxiosAjax, addDate } from '../../js/axios.config';
export default {
    data() {
        return {
            currentTime:'',
            initTime:'' ,
            initDateTime: '',
            BmsList: []
        }
    },
    mounted() {
        const _that = this
		_that.init();
        _that.initTime = setInterval(function() {
            _that.init();
        }, 180000)
        _that.initDateTime = setInterval(function() {
            _that.initDate();
        },8000)
				
    },
    beforeDestroy(){
        const _that = this
        clearInterval(_that.initTime);
        clearInterval(_that.initDateTime);
    },
    methods: {
        init() {
            const _this = this
            const params = {
                cabinetCode: _this.$route.query.cabinetCodes,
                minute: 3,
                module: 2
            }
            AxiosAjax({
                method: 'post',
                url: '/cabinet/cabinet/setPublish',
                data: params,
                success: function (res) {
                    _this.initDate()
                }
            });
        },
        initDate() {
            const _this = this
            _this.id = _this.$route.query.id || '';
            AxiosAjax({
                url: '/cabinet/bms/'+ _this.id,
                success: function (res) {
                    _this.BmsList = []
                    if(res.data.data.length != 0) {
                        _this.currentTime = res.data.data[0].deviceTime
                        res.data.data.forEach((r,i) => {
                            if (i != 0) {
                                _this.BmsList.push(r)
                            }
                        })
                    }
                }
            });
        }
	}
}
</script>
<style scoped>
.current_time {
    position: absolute;
    top:-36px;
    right: 16px;
}
.dis_flex {
    display: flex;
    padding: 0 40px;
}
li {
    flex: 1;
    text-align: left;
}
.dis_flex_div {
    flex: 1;
}
.el-card {
    margin: 10px;
}
.dis_flex_div /deep/ .el-form-item__content {
    text-align: left;
}
.dis_flex_div /deep/ .el-form-item__label {
    text-align: left;
}
.dis_flex_div /deep/ .el-form-item {
    margin-bottom: 0;
}
.title_p {
    text-align: left;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    padding-bottom: 16px;
    font-weight: 600;
}
.schedule {
    width: 100px;
    height: 30px;
    background: #ccc;
    margin: 10px auto;
    margin-left: 0;
}
.schedule span {
    display: block;
    background: yellowgreen;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/Bms.vue